module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: ("md-double-line md-dense competitor " + _vm.otherClass)
  }, [_c('md-list-item', [(_vm.isMine(_vm.tournament)) ? _c('md-menu', {
    attrs: {
      "md-size": "big",
      "md-direction": "bottom-start"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [(!_vm.competitor.isActive) ? _c('md-icon', [_vm._v("not_interested")]) : (_vm.competitor.isEliminated) ? _c('md-icon', [_vm._v("sentiment_dissatisfied")]) : (_vm.competitor.isReadyToCompete) ? _c('md-icon', [_vm._v("how_to_reg")]) : _c('md-icon', [_vm._v("person_outline")])], 1), _vm._v(" "), _c('md-menu-content', [(_vm.competitor.isReadyToCompete) ? _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.toggleReadiness(false)
      }
    }
  }, [_c('span', [_vm._v("Set status to NOT-ready")]), _vm._v(" "), _c('md-icon', [_vm._v("person_outline")])], 1) : (!_vm.competitor.isEliminated) ? _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.toggleReadiness(true)
      }
    }
  }, [_c('span', [_vm._v("Set status to READY")]), _vm._v(" "), _c('md-icon', [_vm._v("how_to_reg")])], 1) : _vm._e(), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.deleteCompetitor()
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', {
    staticClass: "competitor-name"
  }, [_vm._v(_vm._s(_vm.competitor.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.otherInfo))]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.competitor.name) + " - " + _vm._s(_vm.otherInfo))])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.makePayment
    }
  }, [(_vm.competitor.amountPaid) ? _c('span', [_vm._v("$" + _vm._s(_vm.competitor.amountPaid))]) : _c('md-icon', [_vm._v("attach_money")])], 1)], 1)], 1), _vm._v(" "), _c('CompetitorPaymentDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "competitor": _vm.competitor,
      "show": _vm.showPaymentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showPaymentDialog = false
      }
    }
  }), _vm._v(" "), _c('UpdateCompetitorDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "competitor": _vm.competitor,
      "show": _vm.showEditDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showEditDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79abe478","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/competitor.vue
// module id = 455
// module chunks = 1